<template>
  <div class="social-sidebar">
    <v-btn icon :href="links.whatsapp" target="_blank" color="white">
      <v-icon color="green">mdi-whatsapp</v-icon>
    </v-btn>
    <v-btn icon :href="links.messenger" target="_blank" color="white">
      <v-icon color="#0084FF">mdi-facebook-messenger</v-icon>
    </v-btn>
    <v-btn icon :href="links.linkedin" target="_blank" color="white">
      <v-icon color="#0A66C2">mdi-linkedin</v-icon>
    </v-btn>
    <v-btn icon :href="links.twitter" target="_blank" color="white">
      <v-icon color="#000">mdi-twitter</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: {
        whatsapp: "https://wa.me/51928180748",
        messenger: "https://m.me/tuusuario",
        linkedin: "https://linkedin.com/company/tuempresa",
        twitter: "https://twitter.com/tuusuario",
      },
    };
  },
};
</script>

<style scoped>
.social-sidebar {
  position: fixed;
  top: 30%;
  left: 0;
  background-color: #5e1e86; /* Morado institucional */
  padding: 8px 4px;
  border-radius: 0 8px 8px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1000;
}
</style>
